import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { AssociatesResponse, CompanyIdRequest, DepartmentDropResponse, DepartmentModel, ErrorResponse, GlobalResponseObject, GymDepartmentModel, GymDepartmentResponse, GymEmployeesModel, GymEmployeesResponse, SendToEnum } from '@schemax-whatsapp/shared-models';
import { timeStamp } from 'console';
import { Repository } from 'typeorm';
import { GymDbConnection } from '../db-connections/gym-db-connection';
import { ExcelImport } from '../entity/excel-import.entity';
import { CompanyDeptRoleCategoryCodeRequest } from '../whatsapp-broad-cast/model/company-dept-role-cat.request';

@Injectable()
export class GymInfoService {
    constructor(
        private dbConnectionService: GymDbConnection,
        @InjectRepository(ExcelImport) private excelDumpRepo: Repository<ExcelImport>
    ) { }

    /**
     * 
     * @param req 
     * @returns 
     */
    async getGymResources(req: CompanyDeptRoleCategoryCodeRequest): Promise<GymEmployeesResponse> {
        const dbConnection = await this.dbConnectionService.getGymDbConnection('GYM');
        let tableData: ExcelImport[]; 
        if(req.departmentCode) {
            tableData = await this.excelDumpRepo.find({where: {department: req.departmentCode, companyId: req.companyCode}});
        } else {
            tableData = await this.excelDumpRepo.find({where: {companyId: req.companyCode}});
        }
        if (tableData.length == 0) {
            throw new ErrorResponse(0, 'Gym resources not found');
        }
        const users: GymEmployeesModel[] = [];
        tableData.forEach(rec => {
            users.push(new GymEmployeesModel(rec.excelImportId.toString(), rec.memberName, rec.phoneNumber));
        });
        const response = new GymEmployeesResponse(true, 1111, 'Data retrieved successfully', users);
        return response;
    }

    /**
     * 
     * @param req 
     * @returns 
     */
    async getGymVendors(req: CompanyIdRequest): Promise<GymEmployeesResponse> {
        const gymEmpModel: GymEmployeesModel[] = [];
        const vendors: {member_name: string, phone_number: string, ref_code: string}[] = await this.excelDumpRepo.createQueryBuilder('excel_repo')
        .select(`member_name, phone_number, ref_code`)
        .where(`company_id = ${req.companyId} AND ref_type = '${SendToEnum.Vendors}' `)
        .getRawMany();

        if (vendors.length == 0) {
            throw new ErrorResponse(0, 'Gym vendors not found');
        }
        vendors.forEach(rec => {
            gymEmpModel.push(new GymEmployeesModel(rec.ref_code, rec.member_name, rec.phone_number));
        })
        const response = new GymEmployeesResponse(true, 1111, 'Data retrieved successfully', gymEmpModel);
        return response;
    }

    /**
     * 
     * @param req 
     * @returns 
     */
    async getGymCustomers(req: CompanyIdRequest): Promise<GymEmployeesResponse> {
        const gymEmpModel: GymEmployeesModel[] = [];
        const customers: {member_name: string, phone_number: string, ref_code: string}[] = await this.excelDumpRepo.createQueryBuilder('excel_repo')
        .select(`member_name, phone_number, ref_code`)
        .where(`company_id = ${req.companyId} AND ref_type = '${SendToEnum.Customers}' `)
        .getRawMany();

        if (customers.length == 0) {
            throw new ErrorResponse(0, 'Gym vendors not found');
        }
        customers.forEach(rec => {
            gymEmpModel.push(new GymEmployeesModel(rec.ref_code, rec.member_name, rec.phone_number));
        })
        const response = new GymEmployeesResponse(true, 1111, 'Data retrieved successfully', gymEmpModel);
        return response;
    }

    /**
     * 
     * @param req 
     * @returns 
     */
    async getGymDepartments(req: CompanyIdRequest): Promise<GymDepartmentResponse> { 
        const departments: GymDepartmentModel[] = [];

        const departmentsResult: {department: string}[] = await this.excelDumpRepo.createQueryBuilder('excel_repo')
        .select(`DISTINCT department`)
        .where(`company_id = ${req.companyId}`)
        .getRawMany();
        if (departmentsResult.length == 0) {
            throw new ErrorResponse(0, 'Gym vendors not found');
        }
        departmentsResult.forEach(rec => {
            departments.push(new GymDepartmentModel(rec.department, rec.department, rec.department));
        });
        return new GymDepartmentResponse(true, 0, 'Departments retrieved successfully', departments);
    }
}
